import React from 'react'

import styled from '@emotion/styled'
import { IconButton, Dropdown } from 'shared/ui'
import { ArrowDown } from '@groovehq/internal-design-system/lib/assets/icons'

const IconWithTooltip = React.memo(() => {
  return (
    <IconButton
      name="sortDown"
      size="small"
      tooltip="Sorting"
      iconSize={18}
      svg
    />
  )
})

class SortMenu extends React.PureComponent {
  state = { isOpen: false }

  open = () => {
    this.setState({ isOpen: true })
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  render() {
    const { className, sortOrder, is3ColumnView, options } = this.props

    const { isOpen } = this.state
    const trigger = <IconWithTooltip />
    const sortOderText = sortOrder
      ? `${sortOrder.charAt(0).toUpperCase() + sortOrder.slice(1)} first`
      : 'Sort By'

    if (!isOpen && !is3ColumnView) {
      return (
        <div className={className} onClick={this.open}>
          {trigger}
        </div>
      )
    }
    return (
      <>
        {is3ColumnView ? (
          <Dropdown
            text={sortOderText}
            className={className}
            direction="right"
            header="Sorting"
            onClose={this.close}
            icon={<ArrowDown />}
            options={options}
          />
        ) : (
          <Dropdown
            className={className}
            direction="left"
            header="Sorting"
            open
            onClose={this.close}
            icon={null}
            options={options}
            trigger={trigger}
          />
        )}
      </>
    )
  }
}

SortMenu.displayName = 'SortMenu'

const Styled = styled(SortMenu)`
  &&& {
    &.active > .Icon-swap-vert {
      color: ${props => props.theme.color.primary.brand};
    }

    .Icon-swap-vert {
      color: ${props => props.theme.color.monochrome.medium};
      font-size: 16px;
    }
    .Icon-swap-vert:hover {
      color: ${props => props.theme.color.primary.brand};
    }
    &:hover {
      color: ${props => props.theme.color.monochrome.black}};
    }
    -webkit-user-select: none;
    svg {
      margin-left: 0.5em !important;
      font-size: 0.7em !important;
    }
  }
`

export default Styled
